// src/styles/PromptFlowStyles.js

const styles = {
  pageWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center", // Center everything
    width: "100%",
    boxSizing: "border-box",
    padding: "20px",
  },
  navContainer: {
    display: "flex",
    justifyContent: "center",
    marginBottom: "10px", // Space below tabs
    padding: "10px 0",
    width: "100%",
    boxSizing: "border-box",
    borderBottom: "2px solid #ddd", // Optional: Adds a separator
  },
  tab: {
    fontSize: "20px",
    fontWeight: "600",
    padding: "14px 28px",
    borderRadius: "8px",
    border: "none",
    cursor: "pointer",
    transition: "background 0.3s, color 0.3s",
    backgroundColor: "#f0f0f0",
    color: "#333",
    minWidth: "140px",  // Ensures tabs don't shrink below this width
    textAlign: "center", // Centers text inside tab
    display: "inline-block", // Keeps inline behavior but allows width control
  },
  activeTab: {
    backgroundColor: "#3498db",
    color: "white",
    fontWeight: "700",
  },
  resultContainer: {
    width: "100%",  // Ensures it starts with a good width
    minHeight: "250px", // Fixes the height before content loads
    boxSizing: "border-box",
    margin: "20px auto",
    padding: "15px",
    backgroundColor: "#f9f9f9",
    borderRadius: "8px",
    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
    transition: "width 0.3s ease-in-out, min-height 0.3s ease-in-out",
    textAlign: "left",  
    overflow: "hidden", // Prevents awkward resizing jumps
    display: "flex",
    flexDirection: "column",
    justifyContent: "center", // Keeps content centered  
  },
  spinnerContainer: {
    position: "absolute",  // Overlay within the relative parent
    top: "50%",            // Position in the middle of the button container
    left: "50%",
    transform: "translate(-50%, -50%)", // Center both horizontally and vertically
    width: "100%", 
    boxSizing: "border-box",        // Stretch across full width
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(255, 255, 255, 0.8)", // Semi-transparent overlay
    padding: "15px 0",
    borderRadius: "8px",
    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)", // Subtle shadow
    zIndex: 100,  // Ensure it's above buttons
    textAlign: "center",
    pointerEvents: "none", // Prevents blocking interactions when invisible
  },
  spinnerBelow: {
    width: "100%",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "20px", // Adds space below the last saved analysis
    padding: "10px 0",
    backgroundColor: "rgba(255, 255, 255, 0.9)", // Light overlay effect
    borderRadius: "8px",
    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
  },
  thinkingText: {
    fontSize: "18px",
    color: "#555",
    marginBottom: "10px", // Adjust spacing above the spinner
  },
  container: {
    position: 'relative',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: '100%',
    boxSizing: "border-box",
    padding: '20px',
    fontFamily: 'Arial, sans-serif',
    backgroundColor: '#fff',  // Optional background color
  },
  pageContainer: {
    display: 'flex', // Enables horizontal alignment
    flexDirection: 'row', // Ensures sidebar and content are side-by-side
    justifyContent: 'center', // Centers content horizontally
    alignItems: 'flex-start', // Align to the top of the container
    width: '100%', 
    boxSizing: "border-box",
    minHeight: '100vh',
    paddingTop: '20px', // Space from top of the viewport
    backgroundColor: '#fff',
  },
  analysisContainer: {
    marginTop: "20px",
  },
  analysisSection: {
    marginBottom: "15px",
  },
  analysisHeading: {
    fontWeight: "bold",
    fontSize: "16px",
    marginBottom: "5px",
  },
  analysisContent: {
    fontSize: "14px",
    color: "#555",
    lineHeight: "1.6",
  },
  list: {
    paddingLeft: "20px",
    marginBottom: "20px",
  },
  listItem: {
    marginBottom: "10px",
    fontSize: "1rem",
    lineHeight: "1.5",
  },
  textarea: {
      width: '100%',           // Make the input box take full width
      height: '100px',         // Increase the height
      padding: '10px',
      fontSize: '0.9rem',
      borderRadius: '5px',
      border: '1px solid #ccc',
      marginBottom: '20px',
      resize: "vertical",
    },
    guideText: {
      fontSize: "15px",
      color: "#888", // Lighter text color
      marginTop: "10px",
    },
    highlight: {
      fontStyle: "italic",
      fontWeight: "bold",
      color: "#333", // Darker text color
      },
  sectionTitle: {
    color: '#333',
    marginBottom: '1rem',
    borderBottom: '2px solid #007bff',
    paddingBottom: '0.5rem',
    fontSize: "1.2rem",
  },
  summaryText: {
    fontSize: '1.1rem',
    lineHeight: '1.6',
    color: '#555',
    marginBottom: '1.5rem',
  },
  shortlist: {
    listStyleType: 'none',
    padding: '0',
    margin: '0',
  },
  problemItem: {
    backgroundColor: '#e7f3ff',
    padding: '10px',
    borderRadius: '5px',
    marginBottom: '10px',
    lineHeight: '1.5',
    fontSize: '1rem',
    color: '#333',
  },
  vpcLine: {
    fontSize: '1rem',
    marginBottom: '0.5rem',
    backgroundColor: '#f1f8ff',
    padding: '8px',
    borderRadius: '5px',
    color: '#333',
  },
  printButton: {
      padding: '12px 24px',
      backgroundColor: '#007bff',
      color: '#fff',
      border: 'none',
      borderRadius: '5px',
      cursor: 'pointer',
      fontSize: '1rem',
      transition: 'background-color 0.3s ease',
      opacity: 1, // Default opacity for enabled button
    },
    printButtonDisabled: {
      backgroundColor: '#ccc',
      cursor: 'not-allowed',
      opacity: 0.6,
    },
  resetButton: {
    padding: '12px 24px',
    backgroundColor: '#dc3545',
    color: '#fff',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    fontSize: '1rem',
    transition: 'background-color 0.3s ease',
  },
  buttonContainer: {
    display: 'flex',         // Align buttons horizontally
    justifyContent: 'center',
    gap: '20px',             // Add space between buttons
    marginTop: '20px',       // Space above buttons
    width: '100%',           // Ensure buttons span the container width
    boxSizing: "border-box",
    maxWidth: "600px", 
  },
  submitButton: {
    width: "100%",
    boxSizing: "border-box",
    padding: "10px 20px",
    fontSize: "1rem",
    fontWeight: "bold",
    borderRadius: "5px",
    border: "none",
    color: "#fff",
    backgroundColor: "#007bff", // Blue
    cursor: "pointer",
    transition: "background-color 0.3s ease", // Smooth color transition
  },
  consultButton: {
    width: "100%",
    boxSizing: "border-box",
    padding: "10px 20px",
    fontSize: "1rem",
    fontWeight: "bold",
    borderRadius: "5px",
    border: "none",
    color: "#fff",
    backgroundColor: "#FF8C00", // Vibrant orange
    cursor: "pointer",
    transition: "background-color 0.3s ease", // Smooth color transition
  },
  startOverButton: {
    backgroundColor: "#333333",  // Dark grey
    color: "#fff",
    padding: "10px 20px",
    fontSize: "0.9rem",
    //fontWeight: "bold",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    transition: "background-color 0.3s ease",
  },
  redoButton: {
    backgroundColor: "#28a745", // Green
    color: "#fff",
    padding: "10px 20px",
    fontSize: "0.9rem",
    //fontWeight: "bold",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    transition: "background-color 0.3s ease",
  },
  downloadButton: {
    backgroundColor: "#007bff", // Blue
    color: "#fff",
    padding: "10px 20px",
    fontSize: "0.9rem",
    //fontWeight: "bold",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    transition: "background-color 0.3s ease",
  },
  dismissButton: {
    backgroundColor: "#dc3545", // Red
    color: "#fff",
    padding: "10px 20px",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    marginRight: "10px",
  },
  logoutButton: {
    backgroundColor: "#dc3545", // Red
    color: "#fff",
    padding: "10px 20px",
    fontSize: "1rem",
    fontWeight: "bold",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    transition: "background-color 0.3s ease",
  },
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    boxSizing: "border-box",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  modalContent: {
    backgroundColor: "#fff",
    padding: "20px",
    borderRadius: "10px",
    width: "500px",
    maxWidth: "90%",
    textAlign: "center",
  },
  input: {
    width: "90%",
    marginBottom: "10px",
    padding: "10px",
    borderRadius: "5px",
    border: "1px solid #ccc",
  },
  textarea_two: {
    width: "90%",
    fontSize: "0.9rem",
    height: "100px",
    marginBottom: "10px",
    padding: "10px",
    borderRadius: "5px",
    border: "1px solid #ccc",
    resize: "vertical",
  },
  select: {
    width: "90%",
    marginBottom: "10px",
    padding: "10px",
    borderRadius: "5px",
    border: "1px solid #ccc",
  },
  cancelButton: {
    backgroundColor: "#6c757d",
    color: "#fff",
    fontSize: "1rem",
    border: "none",
    padding: "10px 20px",
    borderRadius: "5px",
    cursor: "pointer",
    marginRight: "25px",
  },
  feedbackContainer: {
    position: "fixed",  // ✅ Sticks to the bottom of the viewport
    bottom: "0px",      // ✅ Anchors it at the bottom
    left: "0",
    width: "100%",      // ✅ Full width footer
    boxSizing: "border-box",
    display: "flex",
    justifyContent: "center",  // ✅ Centers content horizontally
    alignItems: "center",
    backgroundColor: "#fff",
    padding: "10px 0",
    boxShadow: "0px -4px 10px rgba(0, 0, 0, 0.1)", // ✅ Shadow to distinguish it as a footer
    zIndex: 100, // Ensures it stays above other content
  },
  feedbackText: {
    fontSize: "16px",
    color: "#333", // Text color
    marginRight: "10px", // Space between text and button
  },
  feedbackButton: {
    fontSize: "16px",
    fontWeight: "bold",
    padding: "8px 16px",
    backgroundColor: "#E65100", // Button color
    color: "#FFFFFF",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    transition: "background-color 0.3s",
  },
  feedbackButtonHover: {
    backgroundColor: "#BF360C", // Button hover color
  },
  deleteButton: {
    background: "#ffcccc",  // Pale red background
    color: "#a10000",       // Deep red text
    border: "2px solid #a10000", // Deep red border
    cursor: "pointer",
    marginLeft: "5px",
    padding: "6px 12px",
    borderRadius: "5px", // Optional: makes the button slightly rounded
    transition: "background 0.2s ease-in-out, color 0.2s ease-in-out",
  },
  newAnalysisContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    boxSizing: "border-box",
    margin: "0 auto",
    padding: "20px",
    backgroundColor: "#ffffff",
    borderRadius: "10px",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
    textAlign: "center",
    transition: "all 0.3s ease-in-out",
  },
  fullScreenView: {
    width: "100%",
    boxSizing: "border-box",
    margin: "0 auto",
    padding: "20px",
    backgroundColor: "#ffffff",
    borderRadius: "10px",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
    transition: "all 0.3s ease-in-out",
    textAlign: "left",
  },
  savedAnalysisContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    maxWidth: "90vw",
    margin: "0 auto",
    padding: "20px",
    backgroundColor: "#ffffff",
    borderRadius: "10px",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
    textAlign: "left",
    transition: "all 0.3s ease-in-out",
  },
  analysisWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "10px", // Adds spacing between the card and delete button
    padding: "10px",
  },
  analysisCard: {
    display: "block", // Ensures stacking
    width: "100%",
    boxSizing: "border-box",
    maxWidth: "90vw",
    padding: "15px",
    marginBottom: "15px",
    backgroundColor: "#ffffff",
    borderRadius: "8px",
    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
    cursor: "pointer",
    transition: "all 0.3s ease-in-out",
  },
  savedAnalysisInfo: {
    fontSize: "14px",
    color: "#555",
    textAlign: "center",
    marginTop: "15px",
    fontStyle: "italic",
  },
  accordionContainer: {
    width: "100%",
    marginBottom: "20px"
  },
  accordionSection: {
    marginBottom: "10px",
    borderRadius: "8px",
    overflow: "hidden",
    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)"
  },
  accordionHeader: {
    width: "100%",
    boxSizing: "border-box",
    padding: "12px 15px",
    textAlign: "left",
    fontSize: "16px",
    fontWeight: "bold",
    cursor: "pointer",
    background: "#f8f8f8",
    border: "none",
    outline: "none",
    transition: "background 0.3s",
  },
  accordionContent: {
    padding: "15px",
    background: "#ffffff",
    borderTop: "1px solid #ddd",
  },
  badge: {
    backgroundColor: "#ff4d4f", // 🔴 Red background
    color: "white",
    fontSize: "12px",
    fontWeight: "bold",
    width: "20px",
    height: "20px",
    borderRadius: "50%", // ✅ Circular shape
    display: "flex", // ✅ Ensures content is centered
    alignItems: "center",
    justifyContent: "center",
    lineHeight: "1", // ✅ Prevents extra spacing
    marginLeft: "4px", // ✅ Small space between "Saved" and the badge
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)",
  }
  
};
  
  export default styles;